import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormControl, FormBuilder, UntypedFormArray, FormGroup } from '@angular/forms';
import { OrganizationService } from '../../../modules/systemconfig/organization/organization.service';
import { ClassesService } from '../../../modules/academics/classes/classes.service';
// import { MatTabGroup } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
    selector: 'app-temporary_reg_form_class_n_photo',
    templateUrl: '../pages/temp_regform_class_nPhoto.component.html',
    styleUrls: ['../css/image_view.css']
})

export class TemporaryClassNPhotoComponent implements OnInit, OnDestroy {

    // @ViewChild('tabGroup') tabGroup: MatTabGroup;

    triggerFileInput() {
        document.getElementById('fileInput').click();
    }

    handleFileSelected(event: any) {
        const selectedFile = event.target.files[0];
    }

    isInputFocused: string = '';
    selectedFile: File | null = null;
    selectedFileUrl: string | null = null;

    onFileSelected(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            this.selectedFile = event.target.files[0];
            // this.service.postData(this.selectedFile);
            this.readSelectedFile();
        }
    }

    readSelectedFile() {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            this.selectedFileUrl = event.target.result;
        };
        reader.readAsDataURL(this.selectedFile as Blob);
    }

    onInputFocus(inputId: string) {
        this.isInputFocused = inputId;
    }

    onInputBlur(inputId: string) {
        if (this.isInputFocused === inputId) {
            this.isInputFocused = '';
        }
    }
    // public student_gender = ['Boy', 'Girl', 'Transgender'];
    // public existing_parent = false;
    // public existing_employee = false;
    // show_exiting_parent_search = true;
    // public existing_user_id: any;
    // public parents$: any;
    // public email_exists = false;
    // private student_master_id: any;
    // public reg_no_exists = false;
    public StudentInfoForm: UntypedFormGroup = this.fb.group({
        class: [''],
        division: [''],
        studentProfilePhoto: ['']
    })
    public student_form_photos = [];
    public student_form_image_priview = {};
    // public all_classes = [];

    get student_info() {
        return this.StudentInfoForm.controls;
    }

    // firstFormGroup = this._formBuilder.group({
    //     firstCtrl: ['', Validators.required],
    // });
    // secondFormGroup = this._formBuilder.group({
    //     secondCtrl: ['', Validators.required],
    // });

    isLinear = false;
    profilepic_size = 0;
    errors: string;
    classData: any;
    divisionData: any;
    // religionData: any;
    // relationData: any;
    // nationalityData: any;
    submitted: boolean = false;
    submit: any
    added: boolean = false;
    message: any;
    saveDisable: boolean = false;
    // cities: any = [];
    // districts: any = [];
    studentFile: File;
    parentFile: File;
    schoolname: any;
    schoolemail: any;
    schoolphone: any;
    schooladdress: any;
    schoollogo: any;
    schooladdressline: any;
    page_flag = 0;
    school: any;
    myForm: FormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private organizationservice: OrganizationService,
        private classesservice: ClassesService,
        private _formBuilder: FormBuilder,
        public translate: TranslateService,
        private router: Router,
    ) { }

    onSubmit() {
        // const formData = new FormData();
        // formData.append('selectedClass', this.myForm.get('selectedClass').value);
        // formData.append('selectedDivision', this.myForm.get('selectedDivision').value);
        // formData.append('studentProfilePhoto', this.myForm.get('studentProfilePhoto').value);

        // console.log("Form Data======>"+this.myForm.get('studentProfilePhoto').value);
        // const file = this.myForm.get('studentProfilePhoto').value;
        // if (file && file.toBlob) {
        //     const reader = new FileReader();
        //     reader.onload = (event) => {
        //         const imageData = event.target.result;
        //         console.log("Image Data===>" + imageData);
          
        //     //   this.service.postData(imageData);
        //     };
          
        //     reader.readAsDataURL(file.toBlob());
        //   } else {
        //     // TODO: Show error message
        //     console.log("Error");
        //   }
        const selectedClass = this.myForm.get('selectedClass').value;
        this.router.navigate(['/admission_form'], { queryParams: { class: selectedClass } });
        

     }

    ngOnInit() {
        // setTimeout(() => {

        this.getschoolname();
        this.getClasses();
        // this.myForm = this._formBuilder.group({
        //     selectedClass: '',
        //     selectedDivision: '',
        //     studentProfilePhoto: ''
        // });
        this.myForm = this._formBuilder.group({
            // name: [''],
            // image: [null],
            selectedClass: [''],
            selectedDivision: [''],
            studentProfilePhoto: [null]
        });
    // }, 1000);
    }

    onStudentImgChanged(event) {
        this.studentFile = event.target.files[0];
    }

    getClasses() {
        this.classesservice.getdistinctclasses().subscribe(data => {
            this.classData = data;
        });
    }

    loadDivisions() {
        const selectedClass = this.myForm.get('selectedClass').value;
        this.classesservice.getdivisions(selectedClass).subscribe(data => {
            this.divisionData = data;
        });
    }
    ngOnDestroy(): void { }

    public getschoolname() {
        this.organizationservice.getactiveorganization().subscribe((data: any) => {
            this.school = data[0];
            this.schoolname = this.school['org_name']
            this.schoolemail = this.school['org_email']
            this.schoolphone = this.school['org_phone']
            this.schooladdress = this.school['org_address_line1']
            this.schooladdressline = this.school['org_address_line2']
            this.schoollogo = this.school['institute_image']
        });
    }
}
